module.exports = __webpack_public_path__ + "static/media/Store_Prizes_Icon.27f787ec.png";